import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import Material from '@primeuix/themes/material';

export const customizedAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E9F1ED',
      100: '#C8DDD5',
      200: '#9FC0B2',
      300: '#6F9D8A',
      400: '#3D6F5A',
      500: '#0E3B2E',
      600: '#0C3327',
      700: '#092820',
      800: '#071E17',
      900: '#04130E',
      DEFAULT: '#0E3B2E', // --color-primary (brand forest green)
    },
    accent: {
      50: '#FFF9D6',
      100: '#FFF2AD',
      200: '#FFE77A',
      300: '#FFDC47',
      400: '#FFD524',
      500: '#FCD20E',
      600: '#E6BD00',
      700: '#C8A500',
      800: '#A98D00',
      900: '#8A7500',
      DEFAULT: '#FCD20E', // --color-accent
    },
  },
});
